import {
  DB_MAIN_DATA,
  DB_MAIN_DATA_SUCCESS,
} from "./actionTypes";

const initialState = {
  mrdeplistcount: [],
};

const CompareQuotation = (state = initialState, action) => {
  switch (action.type) {
    case DB_MAIN_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DB_MAIN_DATA_SUCCESS:
      state = {
        ...state,
        mrdeplistcount: action.payload,
        loading: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }

  return state;
};
export default CompareQuotation;
